(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientCommunication',
	};

	var form_id = 'clientcommunication-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$("[name='form_component_data[" + form.name + "][follow_up]']").on('change', function showHideDateSelector()
		{
			var follow_up_val = $(this).val();
			showHideTaskFields(follow_up_val);
		});

		showHideTaskFields($("[name='form_component_data[" + form.name + "][follow_up]']:checked").val());

		$("#clientcommunication-follow_up_date-time").on('blur', function changeTime()
		{
			var $self    = $(this),
				time     = $self.val(),
				new_time = '',
				parts,
				hour,
				minutes,
				rounded_time;

			// Safari on iOS does not support stepping on the date input, which mean that users would be able to choose times
			// that are not in 15 minute increments. We want to force the 15 minute increments
			if (Adzuki.is_mobile) {
				if (time.length > 0) {
					parts        = time.split(":");
					hour         = parseInt(parts[0]);
					minutes      = parseInt(parts[1]);
					rounded_time = Adzuki.Time.next_fifteen(hour, minutes);

					if (rounded_time.hour < 10) {
						new_time += '0';
					}
					new_time += rounded_time.hour.toString() + ':' + rounded_time.minute;

					$self.val(new_time);
				}
			}
		});

		$("#clientcommunication-follow_up_reminder").on('change', function togg()
		{
			var checked = $(this).is(':checked');

			if (checked === true) {
				$("#send-before").removeClass("hidden");
			} else {
				$("#send-before").addClass("hidden");
			}
		});

		$("#reschedule").on('click', function reschedule(e)
		{
			e.preventDefault();

			if ($('#reschedule-followup').hasClass('hidden')) {
				$('#reschedule-followup').removeClass('hidden');
				rescheduleToggleDisabled(false);
			} else {
				$('#reschedule-followup').addClass('hidden');
				rescheduleToggleDisabled(true);
			}
		});

		// change on the "Add Reminder" radio
		$('.add-reminder').change(function onAddReminderChange(e)
		{
			var add_reminder = parseInt($(this).val());

			if (add_reminder === 1) {
				$('.reminder-field').removeClass('hidden');
			} else {
				$('#' + form_id + 'task_reminder_days').val('');
				$('.reminder-field').addClass('hidden');
			}
		});

		// add reminder radios
		if (
			$('#' + form_id + 'task_add_reminder-0').length > 0
			&& $('#' + form_id + 'task_add_reminder-0').is(':checked')
		) {
			$('.reminder-field').addClass('hidden');
		}
	};

	function showHideTaskFields(follow_up_val)
	{
		if (follow_up_val === '1') {
			$('.task-followup').removeClass('hidden');
		} else {
			$('.task-followup').addClass('hidden');
		}
	}

	function rescheduleToggleDisabled(disabled)
	{
		var disabled_ids = [
			// 'clientcommunication-follow_up_date-date',
			// 'clientcommunication-follow_up_date-date_hidden',
			// 'clientcommunication-follow_up_date-time',
			// 'clientcommunication-follow_up_date-time_hidden',
			// 'clientcommunication-follow_up_reminder',
			'clientcommunication-reminder_advance_minutes'
		];

		if (disabled === false) {
			$('#clientcommunication-reschedule').val(1);
		} else {
			$('#clientcommunication-reschedule').val(0);
		}

		$.each(disabled_ids, function loop(index, ele) {
			$('#' + ele).prop('disabled', disabled);
		});

		$('[name="form_component_data[ClientCommunication][follow_up_reminder]"]').prop('disabled', disabled);
	}

}(jQuery, window.Adzuki || {}));
